import { Button } from '@common/components';
import { Group, UnstyledButton } from '@mantine/core';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import useButtonVisibility from 'src/hooks/useButtonVisibility';
import { IReportIssueProps } from '@common/types/types';
import { IAdminIssue, IReportedIssueDetails } from 'src/store';

import styles from './styles.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useMediaQuery } from '@mantine/hooks';

interface ActionBlockProps {
  locked?: boolean;
  userRole: string;
  item: IReportIssueProps | IAdminIssue | IReportedIssueDetails | undefined;
}

const ActionBlock: FC<ActionBlockProps> = ({ locked, userRole = 'webowner', item }) => {
  const [t] = useTranslation('reported');
  const buttons = useButtonVisibility({ status: item?.status, userRole, item, archived: item?.archived });
  const { id } = useParams<{ id: string }>();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const navigate = useNavigate();
  return (
    <Group w={isMobile ? '100%' : 200} className={styles.actionBlock}>
      {buttons.map((button, index) => (
        <Fragment key={index}>
          {button.label === 'viewDetailsButton' ? (
            <UnstyledButton
              className={styles['view-details-button']}
              component="a"
              role="button"
              tabIndex={0}
              onClick={() =>
                navigate(
                  userRole === 'user'
                    ? `/my-reports/${item?.siteId}/${item?.issueId}`
                    : `/dashboard/${id}/${item?.issueId}`,
                )
              }>
              {t(button.label)}
            </UnstyledButton>
          ) : (
            <Button mobileFullWidth key={index} onClick={button.onClick} color={button.color} small>
              {button.icon ? button.icon : t(button.label)}
            </Button>
          )}
        </Fragment>
      ))}
    </Group>
  );
};

export default ActionBlock;
